import React, { useState } from "react";
import './Header.css';

const Header = ({ toggleTheme }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="logo">
        <a href="https://freeweb3.com" target="_blank" rel="noreferrer">
          <img 
            src="/images/logonimg-freeweb3-freeweb3-logo-2026-900widetrans.png" 
            alt="FreeWeb3 Logo" 
            className="header-logo"
          />
        </a>
      </div>
      
      <button className="mobile-menu-button" onClick={toggleMenu} aria-label="Toggle menu">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          {isMenuOpen ? (
            <>
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </>
          ) : (
            <>
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </>
          )}
        </svg>
      </button>
      
      <nav className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
        <ul>
          <li><a href="https://evidencer.io" target="_blank" rel="noopener noreferrer">Evidencer Introduction</a></li>
          <li><a href="https://unified.evidencer.io" target="_blank" rel="noopener noreferrer">Unified Evidencer</a></li>
          <li><a href="https://forms.evidencer.io" target="_blank" rel="noopener noreferrer">Evidencer Forms</a></li>
        </ul>
      </nav>
      
      {toggleTheme && (
        <button onClick={toggleTheme} className="theme-toggle" aria-label="Toggle dark mode">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
          </svg>
        </button>
      )}
    </header>
  );
};

export default Header;